module.exports = __webpack_public_path__ + "img/amex.b2390f2d.svg";